import axios from 'axios'

import { timeoutRetryRejectionInterceptor } from './axios/interceptors'
import { config } from '../config'

const ssoServerHost = config.sso.SERVER_HOST
const TIMEOUT = 15000

/**
 * A simple function to wrap sso api with default endpoint and request headers
 * @type {Object}
 */
const instance = axios.create({
  baseURL: ssoServerHost,
  timeout: TIMEOUT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

instance.interceptors.response.use(undefined, timeoutRetryRejectionInterceptor)
export default instance
